/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzExMSI+PHBhdGggZD0ibTcuMTIgMi41aDEuNzd2MS43N2gtMS43N3oiLz48cGF0aCBkPSJtNy4xMiA3LjEyaDEuNzd2MS43N2gtMS43N3oiLz48cGF0aCBkPSJtNy4xMiAxMS43M2gxLjc3djEuNzdoLTEuNzd6Ii8+PC9nPjwvc3ZnPg==";